/**
 * Mixin notyfikacji
 * Zawiera metody:
 *  - `notifySuccess(message)` - wyświetla powiadomienie o sukcesie
 *  - `notifyError(message)` - wyświetla powiadomienie o błędzie
 */
export const notificationsMixin = {
    methods: {
      /**
       * Wyświetla notyfikację o sukcesie
       *
       * @param {string} title
       * @param {string} message
       */
      notifySuccess(title, message) {
          alert(title+'\n\n'+message);
      },
  
      /**
       * Wyświetla notyfikację o błędzie
       *
       * @param {string} title
       * @param {string} message
       */
      notifyError(title, message) {
        alert(title+'\n\n'+message);
    }
    }
  };
  